import { __extends } from "tslib";
import { fetchFrequentlyAskedQuestions } from '@gn-audio/core/api/knowledge-base';
import { FaqType } from '../enums/faq-type.enum';
import { FaqItem, FaqSpotBaseController } from '../models';
import { createFaqFilter } from '../utils/create-faq-filter';
import { prioritizeFaqItems } from '../utils/prioritize-faq-items';
var SetupAndPairingFaqSpotController = (function (_super) {
    __extends(SetupAndPairingFaqSpotController, _super);
    function SetupAndPairingFaqSpotController($scope, $q, productContextService, siteLanguage) {
        var _this = _super.call(this, $scope, productContextService, siteLanguage) || this;
        _this.$scope = $scope;
        _this.$q = $q;
        _this.initialLimit = 5;
        _this.moreItemsShown = false;
        _this.onFaqsLoadSuccess = _this.onFaqsLoadSuccess.bind(_this);
        _this.onFaqsLoadFailure = _this.onFaqsLoadFailure.bind(_this);
        return _this;
    }
    SetupAndPairingFaqSpotController.prototype.$onInit = function () {
        var _this = this;
        _super.prototype.$onInit.call(this);
        this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            if (!group) {
                return;
            }
            _this.$scope.limit = 10;
            _this.$scope.initialLimit = _this.$scope.limit;
            _this.$q.when(fetchFrequentlyAskedQuestions(group.groupId, [FaqType.Setup, FaqType.Pairing], createFaqFilter(group, _this.$scope.limit)))
                .then(_this.onFaqsLoadSuccess, _this.onFaqsLoadFailure)
                .then(function () {
                if (_this.$scope.faqItems.length > 0) {
                    _this.showMoreAvailable = (_this.$scope.faqItems || []).length > _this.$scope.limit;
                    _this.showAllAvailable = !_this.showMoreAvailable;
                    return;
                }
                _this.showMoreAvailable = false;
                _this.$scope.limit = 5;
                _this.$scope.initialLimit = _this.$scope.limit;
                _this.$q.when(fetchFrequentlyAskedQuestions(group.groupId, null, createFaqFilter(group, _this.$scope.limit)))
                    .then(function (faqItems) {
                    _this.$scope.faqItems = (faqItems || []).map(function (x) { return new FaqItem(x); });
                    _this.$scope.initialFaqItems = _this.$scope.faqItems.slice();
                })
                    .then(function () {
                    _this.showMoreAvailable = _this.$scope.faqItems.length > _this.$scope.limit;
                    _this.showAllAvailable = !_this.showMoreAvailable;
                });
            });
        });
        this.$scope.searchParametersChanged = function (query) {
            if (query === void 0) { query = ''; }
            _this.$scope.searchQuery = query;
            _this.$scope.showLess();
            _this.moreItemsShown = false;
            _this.$scope.limit = _this.initialLimit;
            var allFaqItems = _this.$scope.allFaqItems;
            if (query) {
                _this.$scope.faqItems = prioritizeFaqItems(allFaqItems, query);
                _this.$scope.filteredFaqItems = prioritizeFaqItems(allFaqItems, query);
            }
            else {
                _this.$scope.faqItems = allFaqItems;
            }
            _this.$scope.initialFaqItems = _this.$scope.faqItems.slice();
        };
        this.$scope.showMoreAvailable = function () {
            return !_this.moreItemsShown && _this.$scope.limit < _this.$scope.faqItems.length;
        };
    };
    SetupAndPairingFaqSpotController.prototype.onFaqsLoadSuccess = function (faqItems) {
        this.$scope.faqItems = (faqItems || []).map(function (x) { return new FaqItem(x); });
        this.$scope.allFaqItems = this.$scope.faqItems.slice();
        this.$scope.initialFaqItems = this.$scope.faqItems.slice();
    };
    SetupAndPairingFaqSpotController.prototype.onFaqsLoadFailure = function () {
        this.$scope.faqItems = [];
        this.$scope.initialFaqItems = [];
        this.$scope.allFaqItems = [];
    };
    SetupAndPairingFaqSpotController.$inject = [
        '$scope',
        '$q',
        'productContextService',
        'siteLanguage',
    ];
    return SetupAndPairingFaqSpotController;
}(FaqSpotBaseController));
export { SetupAndPairingFaqSpotController };
